import RestClient from "../rest.client"

export default class ReverseGeocoderService {
    static async getAddress(lat: number, lon: number) {
        return await RestClient.call({
            method: 'get',
            params: {
                format: 'json',
                addressdetails: 0,
                zoom: 18,
                lat,
                lon
            }
        }, process.env.VUE_APP_REVERSE_GEOCODER_URL)
    }
} 